<script>
	import { goto } from '$app/navigation';
	import { page } from '$app/stores';
	import { variables } from '$lib/variables';
	import { invalidateAll } from '$app/navigation';
	import { onMount } from 'svelte';
	import { fade, fly } from 'svelte/transition';
	import Loader from './Loader.svelte';
	export let item;
	let selected = item.id;
	function onChange(event) {
		selected = Number(event.currentTarget.value);

		// goto(`/${$page.params.category}/${selected}`);
		// invalidateAll()
	}
	let load = false;
	onMount(async () => {
		selected = Number($page.params.id);
		console.log(333, item.get_sizes_origin_product);
	});
</script>

{#if load}
	<Loader />
{/if}
<!-- Colors -->

<!-- Sizes -->
<div class="mt-10">
	<div class="flex items-center justify-between">
		<h4 class="text-xl font-medium text-gray-900">Размеры</h4>
	</div>

	<fieldset class="mt-4">
		<legend class="sr-only">Choose a size</legend>
		<div class="flex flex-wrap gap-4">
			<!-- Active: "ring-2 ring-indigo-500" -->
			{#each item.get_sizes_origin_product as size}
				<div>
					{#if size.total > 0}
						<a
							on:click={() => {
								selected = size.id;
								load = true;
								setTimeout(() => {
									load = false;
								}, 2500);
							}}
							data-sveltekit-noscroll
							href={`/${$page.params.category}/${size.id}`}
							class:bg-custom-gray3={Number(selected) === size.id}
							class:text-white={Number(selected) === size.id}
							class="group relative w-12 h-12 flex items-center justify-center rounded-[25px] border py-3 px-4 text-sm font-medium uppercase focus:outline-none sm:flex-1 cursor-pointer text-gray-900 shadow-sm"
						>
							<input
								checked={selected === size.id}
								on:change={onChange}
								type="radio"
								name="size-choice"
								value={size.id}
								class="sr-only"
								aria-labelledby="size-choice-0-label"
							/>

							<span id="size-choice-0-label " class="text-center"
								>{size.sizes.european || size.sizes.international}</span
							>

							<span class="pointer-events-none absolute -inset-px rounded-md" aria-hidden="true" />
						</a>
					{:else}
						<label
							class="group relative w-12 h-12 flex items-center justify-center rounded-[25px] border py-3 px-4 text-sm font-medium uppercase focus:outline-none sm:flex-1 cursor-pointer text-gray-900 shadow-sm"
						>
							<input
								type="radio"
								name="size-choice"
								value="XXXL"
								disabled
								class="sr-only"
								aria-labelledby="size-choice-7-label"
							/>
							<span id="size-choice-7-label" class="text-center"
								>{size.sizes.european || size.sizes.international}</span
							>

							<svg
								class="absolute inset-0 h-full w-full stroke-2 text-gray-200"
								viewBox="0 0 100 100"
								preserveAspectRatio="none"
								stroke="currentColor"
							>
								<line x1="0" y1="100" x2="100" y2="0" vector-effect="non-scaling-stroke" />
							</svg>
						</label>
					{/if}
				</div>
			{/each}
		</div>
	</fieldset>
</div>
